import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	header: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	header: {
		id: 'issue-create.modal.error-state.header',
		defaultMessage: "Something's gone wrong",
		description: 'Header for error state for issue create dialog',
	},
	description: {
		id: 'issue-create.modal.error-state.description',
		defaultMessage:
			'Our team has been notified. If the problem persists, please contact Atlassian support.',
		description: 'Description for error state for issue create dialog',
	},
});
export default messages;
